/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.configuration', [])
    .factory('configurationService', ConfigurationService)
    .name;

/*@ngInject*/
function ConfigurationService($http, $q) {

    var service = {
        getConfiguration: getConfiguration,
        saveConfiguration: saveConfiguration,
        deleteConfiguration: deleteConfiguration,
        getEntityConfigurations: getEntityConfigurations
    }

    return service;

    function getConfiguration (configurationType, entityType, entityId) {
        var deferred = $q.defer();
        $http.get(`/api/configuration/${configurationType}/${entityType}/${entityId}`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getEntityConfigurations (entityType, entityId) {
        var deferred = $q.defer();
        $http.get(`/api/entity/${entityType}/${entityId}/configurations`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveConfiguration (configuration) {
        var deferred = $q.defer();
        var url = '/api/configuration';
        $http.post(url, configuration).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteConfiguration (configurationType, entityType, entityId) {
        var deferred = $q.defer();
        var url = `/api/configuration/${configurationType}/${entityType}/${entityId}`;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/configuration.service.js